/*
 * @name: configs.js
 * @Descripttion: 定义localStorage常量
 * @Author: Sando
 */

const CONFIG_STORAGE = {
  BOOKING_ENUM: "YH_BOOKING_Enum",
  MEETING_ROOMS: "YH_MEETING_ROOMS",
  HIS_ENUM: "YH_HIS_Enum",
  WORK_VERSION: "YH_WORK_VERSION",
  PD1_ENUM: "YH_PD1_Enum",
  PD1_DRUG: "YH_PD1_Drug",
  PD1_STORE: "YH_PD1_Store",
  SELFCARD_ENUM: "YH_SELFCARD_ENUM",
  currentVersion: 4,
  APP_VERSION: "0.0.2",
};

export { CONFIG_STORAGE };
